import { Grid, Typography, makeStyles, useTheme } from '@material-ui/core';

interface Props {
  value?: string;
  maxLength?: number;
  label: string;
}

export const isOverCharacterLimit = (value?: string, maxLength?: number) =>
  !!maxLength && !!value && value.length > maxLength;

export default function InfoSection({ value, maxLength, label }: Props) {
  const classes = useStyles();
  const theme = useTheme();

  const currentLength = value?.length || 0;
  const isOverLimit = isOverCharacterLimit(value, maxLength);
  const color = isOverLimit
    ? theme.palette.error.main
    : theme.palette.text.secondary;

  return (
    <Grid
      container
      direction='row'
      justifyContent={isOverLimit ? 'space-between' : 'flex-end'}
      alignItems='center'
    >
      {isOverLimit && (
        <Typography className={classes.message} style={{ color }}>
          {label} is too long (maximum is {maxLength} characters)
        </Typography>
      )}
      {!!maxLength && (
        <Typography className={classes.counter} style={{ color }}>
          {currentLength} / {maxLength}
        </Typography>
      )}
    </Grid>
  );
}

const useStyles = makeStyles(() => ({
  message: {
    fontSize: 12,
    marginTop: 4,
  },
  counter: {
    fontSize: 12,
    marginTop: 4,
    marginRight: 4,
  },
}));
